import React, { useEffect, useState } from "react";
import { Page, PendingButton, LoadingMsg } from "components/common";
import moment from "moment";
import { FormGroup, Label, Row, Col } from "reactstrap";
import { Trans } from "react-i18next";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import { Table } from "reactstrap";
import { useHistory } from 'react-router';
import { Link } from "react-router-dom";
import { exportDownload } from "services/util";


const PayableReceivable = ({ client, t, selectedOrganisation }) => {
  const [data, setData] = useState(null);
  const [pending, setPending] = useState(false);
  const history = useHistory();

  const [item, setItem] = useState({
    fromDate: moment().subtract(1, "quarter").startOf("month").format("YYYY-MM-DD"),
    toDate: moment().subtract(1, "quarter").endOf("month").format("YYYY-MM-DD")
  });

  const downloadReport = async () => {
    setPending(true);
    const resp = await exportDownload(client,  `xero_actions/${selectedOrganisation.id}/reported_documents`, 'reported_documents.xlsx', {...item, export:true})
    setPending(false);
    return resp
  }

  const getReport = () => {
    for(var key in item) {
      if(item[key] === "" || item[key] === null) {
        NotificationManager.error(t(`All form values are required`))
        return
      }
  }
    setHistory()
    loadReport()
  }

  const loadReport = async () => {
    setPending(true);
    try {
      let resp = await client
        .get(`xero_actions/${selectedOrganisation.id}/reported_documents`, {
          params: item,
        })
        .get("data");
      setData(resp);
    } catch (ex) {
      if (ex.response && ex.response.data) {
        NotificationManager.error(t(ex.response.data));
      } else {
        NotificationManager.error(t("An unexpected error occurred"));
      }
    }
    setPending(false);
  };

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const fromDate = params.get('from')
    const toDate = params.get('to')
    setItem((old) => (
      {...old, 'fromDate':fromDate? fromDate : moment().startOf("month").format("YYYY-MM-DD"),
      'toDate':toDate? toDate : moment().endOf("month").format("YYYY-MM-DD")
    }
  ))
  }, []);

  const setHistory = () => {
    history.push({
      pathname: '/reports/reported_documents',
      search: `?from=${item.fromDate}&to=${item.toDate}`
    })
  }


  return (
      <Page title="Reported Documents" className="inv-table">
        <div className="d-print-none inv-tabs ">
          <div className="mt-3">
            <Row>
              <Col className="col-2">
                <FormGroup className="">
                <Label>
                  <Trans>From Date</Trans>
                </Label>
                <DatePicker
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selected={item.fromDate ? moment(item.fromDate) : null}
                  className="form-control"
                  dateFormat="D MMM YYYY"
                  onChange={(value) => {
                    setItem({...item, fromDate:value? moment(value).format("YYYY-MM-DD") : null});
                  }}
                />
              </FormGroup>
              </Col>
              <Col className="col-2">
                <FormGroup className="">
                  <Label>
                    <Trans>To Date</Trans>
                  </Label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={item.toDate ? moment(item.toDate) : null}
                    className="form-control"
                    dateFormat="D MMM YYYY"
                    onChange={(value) => {
                      setItem({...item, toDate:value? moment(value).format("YYYY-MM-DD") : null});
                    }}
                  />
                </FormGroup>
              </Col>
              <Col className="col-1">
                <div className="d-flex">
                  <div className="">
                    <FormGroup>
                      <Label>&nbsp;</Label>
                      <PendingButton
                        color="primary"
                        size="sm"
                        className="d-block"
                        onClick={getReport}
                        pending={pending}
                      >
                        <Trans>Update</Trans>
                      </PendingButton>
                    </FormGroup>
                  </div>
                  <div className="">
                    <FormGroup>
                      <Label>&nbsp;</Label>
                      <PendingButton size="sm" color="primary" className="d-block"
                        pending={pending} onClick={downloadReport}>
                        <Trans>Export</Trans><span className="mx-1" /><i className="fas fa-file-excel" />
                      </PendingButton>
                    </FormGroup>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        {/*data ? <SalesTaxContainer report={data} /> : null*/}
        {pending ? (
          <LoadingMsg />
        ) : (
          <div>
              {data && data?.MainRows && 
              <div className="">
                <div className="header mt-3 border px-3 pt-3 pb-2">
                    <p className="h4 mb-3">{data.ReportTitles[0]}</p>
                    <p>{data.ReportTitles[1]}</p>
                    <p>{data.ReportTitles[2]}</p>
                </div>
                <div className="border my-3 p-3">
                  <Table responsive className="text-left">
                      <thead>
                        <tr>
                          {data?.MainRows?.Header?.map((i) => (
                              <th className="text-left h6">
                                <Trans>{i}</Trans>
                              </th>                
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.MainRows?.Rows?.length> 0? 
                          data.MainRows.Rows.map((row) => (
                            <tr>
                              {row?.Cells?.map((cell) =>(
                                  <td className={`text-left ${row.RowType==='SummaryRow'? 'font-weight-bold h6' : (row.RowType==='TotalRow' && '') }`}>
                                    {cell.Value?.Name ? 
                                      <Link to={cell.Value.Url} className="text-success">
                                        <Trans>{cell.Value.Name}</Trans>
                                      </Link>
                                      :
                                      <Trans>{cell.Value}</Trans>
                                  }
                                  </td>
                              ))  
                            }
                            </tr>
                          ))
                          :
                          <tr>
                            <td className="text-center p-2" colspan={data?.MainRows?.Rows?.length || "17"}>
                              <Trans>No Transactions</Trans>
                            </td>
                          </tr>
                          
                        }
                      </tbody>
                  </Table> 
                </div>
              </div>
              }
          </div>
        )}
    </Page>
  );
};


export default PayableReceivable;
